import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/*************仕入先支払用*************/

/**
 * 仕入先支払一覧：検索条件リストの初期化(状態、支払状態)
 */
export function initCustPaySearchList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitCustPaySearchList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 仕入先支払一覧：仕入先支払基本情報の検索
 */
export function searchCustPayBasic(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchCustPayBasic, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 仕入先支払一覧：仕入先支払No.によると、仕入先支払基本情報と明細情報の削除
 */
export function deleteCustPayBasicByPayNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteCustPayBasicByPayNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 仕入先支払詳細画面：仕入先支払No.によると、仕入先支払基本情報と明細情報の検索
 */
export function searchCusPayDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchCusPayDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 支払入荷選択画面情報の検索
 */
export function searchJpReceSelectForm(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchJpReceSelectForm, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 支払入荷選択画面情報の検索:⇒仕入先支払明細画面
 */
export function searchJpReceToPayInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchJpReceToPayInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 支払入荷画面: 支払入荷No.によると、支払入荷基本情報と明細情報の更新
 */
export function updateCusPayDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateCusPayDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 支払入荷画面: 支払入荷No.によると、支払入荷基本情報と明細情報の新規追加
 */
export function addCusPayDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddCusPayDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文情報と日本入荷情報の検索
 */
export function searchOrderJpReceInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchOrderJpReceInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * クローズデータ選択画面情報の検索
 */
export function searchCloseSelectForm(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchCloseSelectForm, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * クローズデータ選択画面情報の検索
 */
export function searchCloseToPayInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchCloseToPayInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
